import UseGetActivityPanel from '../hooks/useGetActivityPanel';
import ChartInfo from './components/chart';
import DashboardInfo from './components/info';

const ActivityPanel = () => {
  const {activityReport} = UseGetActivityPanel();
  return (
    <>
      <div className="mt-5">
        <h6 className="color-gray-1">بازدید فروشگاه</h6>
      </div>
      <div className="pt-3">
        <ChartInfo infoList={activityReport?.views || []} />
      </div>
      <div className="mt-5">
        <DashboardInfo
          commentCount={activityReport?.comment || 0}
          rate={activityReport?.rate || 0}
        />
      </div>
    </>
  );
};

export default ActivityPanel;
